const IMAGE_EXTENSIONS = ['gif', 'jpg', 'png', 'jpeg', 'webp'];
const DOCUMENT_EXTENSIONS = ['pdf', 'ppt', 'pptx', 'doc', 'docx', 'txt', 'csv', 'xlsx', 'xls'];

export const isImageExtension = (filename) => {
  if (!filename) return false;
  const ext = filename.split('.').pop()?.toLowerCase();
  return IMAGE_EXTENSIONS.includes(ext);
};

export const isDocumentExtension = (filename) => {
  if (!filename) return false;
  const ext = filename.split('.').pop()?.toLowerCase();
  return DOCUMENT_EXTENSIONS.includes(ext);
};

export const getAcceptedTypeMode = (acceptedTypes) => {
  if (!acceptedTypes) return '';
  const normalized = acceptedTypes.toLowerCase();
  const hasImages = IMAGE_EXTENSIONS.some((e) => normalized.includes(e));
  const hasDocs = DOCUMENT_EXTENSIONS.some((e) => normalized.includes(e));

  if (hasImages && hasDocs) return 'mixed';
  if (hasImages) return 'image';
  if (hasDocs) return 'document';
  return '';
};

export const getFileFormat = (acceptedTypes, fileType = '') => {
  if (!acceptedTypes) return '';

  const ext = fileType.toLowerCase();

  if (IMAGE_EXTENSIONS.includes(ext)) return `image/${ext}`;
  if (DOCUMENT_EXTENSIONS.includes(ext)) return 'document';

  return getAcceptedTypeMode(acceptedTypes);
};
